import { useState, useEffect } from "react";
import { authFetch } from "../../App";
import { Loader2 } from "lucide-react";

function useAuthImage(path) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    if (!path) { setUrl(null); return; }
    let revoked = false;
    (async () => {
      try {
        const res = await authFetch(`${process.env.REACT_APP_BACKEND_URL}/api/files/${path}`);
        if (!res.ok) return;
        const blob = await res.blob();
        if (revoked) return;
        setUrl(URL.createObjectURL(blob));
      } catch {}
    })();
    return () => { revoked = true; setUrl((prev) => { if (prev) URL.revokeObjectURL(prev); return null; }); };
  }, [path]);
  return url;
}

export function AuthImage({ path, alt, className, onClick, ...props }) {
  const src = useAuthImage(path);
  if (!src) return <div className={`flex items-center justify-center text-gray-300 ${className || ""}`}><Loader2 className="w-5 h-5 animate-spin" /></div>;
  return <img src={src} alt={alt} className={className} onClick={onClick} {...props} />;
}
